import { CART_MODULE } from "@/api_framework/api_config";
import { ICartUserInvoiceListResponse } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";
import { setInoviceList } from "@/app_redux/reducers/slices/auth/cart_slice";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { stat: boolean; message: string };

export interface IInvoiceProps {
  start_date: string | null;
  end_date: string | null;
  statuses: Array<string>;
  user_id?: string;
  logged_in_clinic_id?: string;
}
export const useCartInvoiceListAPI = () => {
  const configuration = useConfiguration();
  const [emi_meta_data, setEmiMetaData] = useState<any>(null);
  const [online_payment_details, setOnline_payment_details] = useState<any>(null);
  const [cmbookingRecommendations, setCmbookingRecommendations] = useState<any>([]);
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (fromData: IInvoiceProps, source) => {
      try {
        dispatch(
          setLoading({
            key: "isCustomerInvoiceTableInProgress",
            status: true,
          }),
        );
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: ICartAPIResponse | null = await axios
          .post(`${CART_MODULE?.USER_LEVEL_INVOICE?.baseURL}?source=${source}`, fromData, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICartUserInvoiceListResponse>) => {
            if (res.data.status) {
              dispatch(setInoviceList(res.data.data?.invoices));
              setEmiMetaData(res.data.data?.emi_meta_data);
              setOnline_payment_details(res.data.data?.online_payment_details);
              setCmbookingRecommendations(res.data.data?.cm_booking_recommendations);
              dispatch(
                setLoading({
                  key: "isCustomerInvoiceTableInProgress",
                  status: false,
                }),
              );
              return { stat: true, message: "" };
            } else {
              dispatch(setInoviceList([]));
              setEmiMetaData(null);
              setOnline_payment_details(null);
              setCmbookingRecommendations([]);
              dispatch(
                setLoading({
                  key: "isCustomerInvoiceTableInProgress",
                  status: false,
                }),
              );
              return { stat: false, message: "" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            dispatch(setInoviceList([]));
            setEmiMetaData(null);
            setOnline_payment_details(null);
            setCmbookingRecommendations([]);
            captureError(e);
            dispatch(
              setLoading({
                key: "isCustomerInvoiceTableInProgress",
                status: false,
              }),
            );
            return { stat: false, message: "" };
          });
        return response;
      } catch (e) {
        dispatch(setInoviceList([]));
        setEmiMetaData(null);
        setOnline_payment_details(null);
        setCmbookingRecommendations([]);
        dispatch(
          setLoading({
            key: "isCustomerInvoiceTableInProgress",
            status: false,
          }),
        );
        captureError(e);
      }
    },
    [dispatch],
  );

  return { execute, emi_meta_data, setEmiMetaData, online_payment_details, cmbookingRecommendations };
};
